import { Route } from 'react-router-dom';
import { ROUTES } from './config/RoutesName';
import {
  AddItemDetails,
  RestaurentCategoryList,
  ContactUs,
  Faq,
  About,
  PrivacyPolicy,
  Reciept,
  ReviewList,
  ScanQrCode,
  OrderDetails,
  TermsConditions,
  PageNotFound,
  Payment,
} from './pages';
import NonAuthLayout from './layout/NonAuthLayout';
import AuthLayout from './layout/AuthLayout';
import Home from './pages/Home/index-ref';
import RestaurantDetails from './pages/RestaurantDetails';
import AddToCartRefactored from './pages/AddCart/index-ref';
import OtpVerification from './pages/OTP/OtpVerification';
import Cart from './pages/Cart/index-ref';
import Landing from './pages/Landing';

const routes = (
  <>
    <Route element={<NonAuthLayout />}>
      <Route
        path={ROUTES.HOME}
        element={
          process.env.NODE_ENV === 'production' && !window.location.host.includes('dev') ? <Landing /> : <Home />
        }
      />
      <Route path={ROUTES.DETAILS + '/:restaurantId'} element={<RestaurantDetails />} />
      <Route path={ROUTES.CART} element={<Cart />} />
      <Route path={ROUTES.ADDITEM} element={<AddToCartRefactored />} />
      <Route path={ROUTES.OTP} element={<OtpVerification payment={true} />} />
      <Route path={ROUTES.CATEGORY + '/:categoryId'} element={<RestaurentCategoryList />} />
      <Route path={ROUTES.PAYMENT} element={<Payment />} />
    </Route>

    <Route element={<AuthLayout />}>
      <Route path={ROUTES.RECEIPT} element={<Reciept />} />
      <Route path={ROUTES.PHONEVERIFY} element={<OtpVerification />} />
    </Route>

    <Route path={ROUTES.ORDERDETAILS + '/:orderId'} element={<OrderDetails />} />
    <Route path={ROUTES.CONTACTUS} element={<ContactUs />} />
    <Route path={ROUTES.FAQ} element={<Faq />} />
    <Route path={ROUTES.ABOUT} element={<About />} />
    <Route path={ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
    <Route path={ROUTES.REVIEWS + '/:restaurantId'} element={<ReviewList />} />
    <Route path={ROUTES.SCAN} element={<ScanQrCode />} />
    <Route path={ROUTES.TERMSCONDITIONS} element={<TermsConditions />} />
    <Route path='*' element={<PageNotFound />} />
  </>
);

export default routes;
